import React from 'react';
import { X } from 'lucide-react';
import { Section } from './Shared';
export const PainPoints = () => {
  const points = ['El dinero entra pero desaparece sin explicación.', 'Siempre aparece un gasto imprevisto cuando algo mejora.', 'Sentís que trabajás el doble y ganás la mitad.', 'Las oportunidades llegan pero nunca se concretan.', 'Hay peleas constantes por plata en tu hogar.', 'Sentís que la envidia de otros frena tu progreso.', 'Los negocios que intentás no despegan.', 'Hay semanas enteras donde el dinero simplemente no aparece.', 'Sentís que otros progresan y vos te quedás en el mismo lugar.', 'Vivís con la sensación permanente de que "algo" te está frenando.'];
  return <Section className="max-w-4xl" data-id="element-339">
      <div className="text-center mb-12" data-id="element-340">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-display font-bold mb-6 leading-tight text-brand-darkGreen" data-id="element-341">
          ¿CUÁNTO DINERO MÁS VAS A DEJAR DE GANAR POR NO LIMPIAR LO QUE ESTÁ
          BLOQUEANDO TU CASA?
        </h2>
        <div className="text-brand-text mb-4 text-sm md:text-base max-w-2xl mx-auto space-y-4" data-id="element-342">
          <p data-id="element-343">
            Trabajás. Te esforzás. Hacés lo que podés. Pero el dinero no
            alcanza, no fluye, no llega como debería.
          </p>
          <p data-id="element-344">
            El problema no es la inflación. No es la crisis. No es la mala
            suerte.
          </p>
        </div>

        <p className="text-lg md:text-xl font-medium text-brand-error mt-6 font-serif italic" data-id="element-345">
          El problema es que nadie te enseñó a limpiar lo que realmente está
          frenando tu economía.
        </p>
      </div>

      <div className="glass-panel p-6 md:p-10 rounded-3xl mb-12 bg-white/70 border-brand-gold/20" data-id="element-346">
        <h3 className="font-serif font-bold mb-6 flex items-center text-brand-darkGreen text-base md:text-lg" data-id="element-347">
          <X className="w-6 h-6 text-brand-error mr-2 shrink-0" data-id="element-348" /> LO QUE PASA
          CUANDO TU CASA ESTÁ ENERGÉTICAMENTE BLOQUEADA:
        </h3>
        <ul className="space-y-4" data-id="element-349">
          {points.map((point, i) => <li key={i} className="flex items-start" data-id="element-350">
              <X className="w-5 h-5 text-brand-error/80 mr-3 mt-0.5 shrink-0" data-id="element-351" />
              <span className="text-brand-text text-sm md:text-base" data-id="element-352">
                {point}
              </span>
            </li>)}
        </ul>
      </div>

      <div className="text-center" data-id="element-353">
        <h3 className="text-xl md:text-3xl font-display font-bold green-gradient-text" data-id="element-354">
          ¿Y SI ESTA FUERA LA ÚLTIMA VEZ QUE VIVÍS ASÍ?
        </h3>
      </div>
    </Section>;
};